export default __webpack_public_path__ + "static/media/KUW.073a20da.svg";